import { IImageMessage } from '@/store/messages/messages.ts';
import { ShowOnlyImageProps } from './IImageViewer.ts';
import globalEvents from '@/services/GlobalEvents/GlobalEvents.ts';
import { Events } from '@/services/GlobalEvents/constants.ts';

export const show = (message: IImageMessage) => {
  globalEvents.emit(Events.showImageMessage, message)
}

export const showOnlyImage = ({imageName, url}: ShowOnlyImageProps) => {
  globalEvents.emit(Events.showImage, {
    url,
    imageName: imageName || 'image.jpg'
  })
}
